<template>
  <!--套餐-->
  <section class="layer-section sku-suites" v-if="suites && suites.length">
    <h3 class="section-title">套餐</h3>
    <div class="section-content package">
      <!--套餐选择按钮-->
      <div class="btn-wrapper">
        <div class="section-btn" :code="0" @click="checkSuite({})" :class="{ checked: !currentSuite.id }">
          <p class="name">官方标配</p>
          <p class="subname">不享受优惠</p>
        </div>
      </div>
      <div class="btn-wrapper" v-for="(suite, idx) in suites" :key="idx">
        <div
          class="section-btn"
          :code="suite.id"
          @click="checkSuite(suite)"
          :class="{ checked: currentSuite.id == suite.id }"
        >
          <p class="name">{{ suite.name }}</p>
          <p class="subname">¥{{ suite.totalPrice | formatNumber }} 省¥{{ suite.discountAmount | formatNumber }}</p>
        </div>
      </div>

      <!--套餐内容-->
      <div class="layer-panel" v-if="currentSuite.id">
        <div class="header">
          <span class="title">{{ currentSuite.name }}</span>
          <span class="subtitle">
            ¥{{ currentSuite.totalPrice | formatNumber }} 省¥{{ currentSuite.discountAmount | formatNumber }}
          </span>
        </div>
        <ul class="panel-detail">
          <li class="item">
            <img
              class="item-img"
              v-if="(skuInfo.imageInfos || []).length"
              :src="skuInfo.imageInfos[0].smallPic"
              alt=""
            />
            <div class="desc">
              <p class="name">{{ skuInfo.skuName }}</p>
              <div class="color">
                <p class="value">{{ skuInfo.colorName }}</p>
              </div>
            </div>
            <span class="price">¥{{ skuInfo.salePrice | formatNumber }}</span>
          </li>
          <li class="item" v-for="(bundle, idx) in currentSuite.bundleSkus" :key="idx">
            <img class="item-img" :src="bundle.imgUrl" alt="" />
            <div class="desc">
              <p class="name">{{ bundle.name }}</p>
              <div class="color">
                <p class="value">{{ bundle.colorName }}</p>
              </div>
            </div>
            <span class="price">¥{{ bundle.salePrice | formatNumber }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'sku-suites',
  props: {
    skuInfo: Object,
    suites: Array,
    currentSuite: Object
  },
  methods: {
    // 切换套餐
    checkSuite(suite) {
      this.$emit('suiteClick', suite)
      // 当点击的时当前已选中的套餐时，不做处理
      if (this.currentSuite.id == suite.id) {
        return false
      }
      // 通知父组件套餐更改
      this.$emit('suiteChange', suite.id)
    }
  }
}
</script>
